import { useState } from 'react';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore, { useSolutionDetails } from '../../redux';
import { SolutionOmniverseApp } from '../../types';
import { API_DELETE_OMNIVERSE_APP } from '../../constants';

type Props = {
  app: SolutionOmniverseApp | null;
  sitesId?: string;
  id?: string;
  open: boolean;
  onClose: ModalCloseHandler;
  onSuccess: () => void;
};

function SolutionOmniverseDeleteModal({
  app,
  sitesId,
  id,
  open,
  onClose,
  onSuccess,
}: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);

  const [handleDelete, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generateApiPath(API_DELETE_OMNIVERSE_APP, {
          solutionId,
          siteId: sitesId,
          appId: app?.id,
          twinId: id,
        }),
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: 'App Deleted',
        text: `${app?.title} has been deleted successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.omniverseApp({
        solutionId,
        siteId: sitesId,
        appId: app?.id,
        twinId: id,
      });
      onSuccess();
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Delete Application"
      loading={loading}
      onClose={onClose}
      onConfirm={handleDelete}
      cancelBtnText="No"
      confirmBtnText="Yes"
      maxWidth="sm"
      fullWidth
    >
      Are you sure you want to delete the Application?<br></br>
      <b>{app?.title || ''}</b>
    </ModalDialog>
  );
}

export default SolutionOmniverseDeleteModal;
